import React from "react";
import Button from "../atoms/Button";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import ArrowRight from "../atoms/icons/ArrowRight";
import Flex from "../atoms/Flex";
import Paragraph from "../atoms/Paragraph";

const StyledArrowRight = styled(ArrowRight)`
  width: 15px;
  height: 11px;
  fill: white;
`;

const Logo = styled.img`
  max-width: 100px;
  margin-bottom: 25px;

  @media only screen and (min-width: 576px) {
    margin-bottom: 0;
  }
`;

const StyledFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  margin: 20px 0 0;

  @media only screen and (min-width: 576px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

const ObjectionModal = ({ dossier, objectionFallbackUrl, objectionUrl }) => {
  const { t } = useTranslation();

  return (
    <>
      {objectionFallbackUrl && (
        <Paragraph>
          <Trans
            i18nKey={"objection.text"}
            components={{ anchor: <a href="/contact" /> }}
          />
        </Paragraph>
      )}
      {objectionUrl && (
        <Paragraph>
          <Trans
            i18nKey={"objection.static_url_text"}
            components={{ anchor: <a href="/contact" /> }}
          />
        </Paragraph>
      )}
      <StyledFlex>
        {objectionFallbackUrl && <Logo src="/img/p1-logo.png" />}
        <a
          href={
            objectionFallbackUrl
              ? "/bezwaar?license_plate=" +
                dossier.license_plate +
                "&registration_date_time=" +
                dossier.registration_date_time +
                "&objection_fallback_url=" +
                objectionFallbackUrl +
                "&user=" +
                localStorage.getItem("access_token")
              : objectionUrl
          }
          target={"_blank"}
        >
          <Button reversed secondary icon={<StyledArrowRight />}>
            {t("objection.external_form_button_label")}
          </Button>
        </a>
      </StyledFlex>
    </>
  );
};

export default ObjectionModal;
